const angular = require('angular');

const NewProductsService = require('./newproducts.service');
const { newProductsNavComponentDefinition } = require('./newproducts-navigation.component');
const { newProductsTileListComponentDefinition } = require('./newproducts-tile-list.component');

angular.module('wowApp.shop')
    .service('NewProductsService', ['Restangular', NewProductsService])
    .component('wowNewProductsNav', newProductsNavComponentDefinition)
    .component('wowNewProductsTileList', newProductsTileListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/newproducts/index.js